<h2 mat-dialog-title>Value Sets for {{code}} {{display}}</h2>

<mat-dialog-content class="mat-typography">
  @for (scope of scopes; track scope) {
    <div>
      <p>{{scope.scope}}</p>
      <ul>
        @for (valueSet of scope.valueSets; track valueSet) {
          <li>
            <mat-checkbox [checked]="valueSet.isPinned" (change)="onPinnedChanged(valueSet, $event.checked)">
              {{valueSet.cleanName}}
            </mat-checkbox>
          </li>
        }
      </ul>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCloseClick()">Close</button>
</mat-dialog-actions>
